import { Card, CardHeader, CardBody } from "reactstrap";
import { ResponsiveBar } from "@nivo/bar";
import { FiInbox } from "react-icons/fi";
import { useTranslation } from "react-i18next";

interface BasicBarChartProps {
    title: string;
    data: any[];
    indexBy: string;
    keys: string[];
    xLegend?: string;
    yLegend?: string;
    height?: number | string;
    colors?: any;
}

const BasicBarChart = ({
    title,
    data,
    indexBy,
    keys,
    xLegend = "Categoría",
    yLegend = "Valor",
    height = 300,
    colors,
}: BasicBarChartProps) => {
    const { t } = useTranslation();
    const hasData = data && data.length > 0;

    return (
        <Card className="w-100 h-100">
            <CardHeader>
                <h5 className="mb-0">{title}</h5>
            </CardHeader>
            <CardBody
                style={{ height, ...(hasData ? {} : { display: "flex", justifyContent: "center", alignItems: "center" }), }}>
                {hasData ? (
                    <ResponsiveBar
                        data={data}
                        keys={keys}
                        indexBy={indexBy}
                        groupMode="grouped"
                        margin={{ top: 50, right: 30, bottom: 60, left: 60 }}
                        padding={0.3}
                        {...(colors ? { colors } : {})}
                        axisBottom={{
                            legend: `${xLegend}`,
                            legendOffset: 32,
                        }}
                        axisLeft={{
                            legend: yLegend,
                            legendOffset: -40,
                        }}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        tooltip={({ id, value, indexValue }) => (
                            <div
                                style={{
                                    background: "var(--vz-card-bg, white)",
                                    padding: "6px 9px",
                                    border: "1px solid var(--vz-border-color, #ccc)",
                                    borderRadius: "4px",
                                    color: "var(--vz-body-color, inherit)",
                                }}
                            >
                                <strong>{indexValue}</strong>
                                <br />
                                {id}: {value}
                            </div>
                        )}
                    />
                ) : (
                    <div style={{ textAlign: "center", color: "#888" }}>
                        <FiInbox size={48} style={{ marginBottom: 10 }} />
                        <div>{t('shared.chart.noData')}</div>
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default BasicBarChart;